
class CreateFacilityReq {
 
    constructor(){
        this.Id = undefined;
        this.Name = undefined;

        this.Description = undefined;
        this.Category = undefined;
        this.InitialPrice = undefined;
        this.CurrentPrice = undefined;
        this.DepreciationRate = undefined;
        this.DatePurchased = undefined;
        this.AccountingEntryId = undefined;
        this.CreateAccountingEntry = undefined;
        this.TypeId = undefined;
        this.Image = undefined;

        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        };

    }
}

export default CreateFacilityReq;